// extracted by mini-css-extract-plugin
module.exports = {"link":"publicLink_link__1H_eU","btn":"publicLink_btn__X_b-_"};